import { SET_LINK_ORGA, CLOSE_LINK_ORGA } from "../types/linkOrgaTypes";

const initialState = {
  toLink: {},
};

const LinkOrgaReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LINK_ORGA:
      return { ...state, toLink: action.payload };
    case CLOSE_LINK_ORGA:
      return {
        ...state,
        toLink: { ...state.toLink, exist_free_account: action.payload },
      };
    default:
      return state;
  }
};

export default LinkOrgaReducer;
